import { render, staticRenderFns } from "./TopBarTitle.vue?vue&type=template&id=37db23de"
import script from "./TopBarTitle.vue?vue&type=script&lang=js"
export * from "./TopBarTitle.vue?vue&type=script&lang=js"
import style0 from "./TopBarTitle.vue?vue&type=style&index=0&id=37db23de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports